<aw-drop-down
  [formControl]="shopLanguageControl"
  name="name"
  id="shop-language-drop-down"
  [options]="languageStore.activeLanguages()">
</aw-drop-down>
